'use client';

import { unstable_batchedUpdates as unstableBatchedUpdates } from 'react-dom';

import { IUserTokenInfo } from '../types';
import { useAuthStore } from '../useAuthStore';

/**
 * This is used to update the store token information outside of the react
 * components.
 *
 * Using `unstable_batchedUpdates` to prevent inconsistent state updates.
 * [Zombie child, yet again](https://github.com/pmndrs/zustand/issues/302).
 *
 * TODO: Look into why this is deprecated for react-query v5 with react > version 18
 * - https://tanstack.com/query/latest/docs/framework/react/guides/migrating-to-v5#no-longer-using-unstable_batchedupdates-as-the-batching-function-in-react-and-react-native

 * @param userTokenInfo IUserTokenInfo - The `token`, `refreshToken` and `userId`.
 */
export const updateAuthStoreTokenInfo = (userTokenInfo: IUserTokenInfo) => {
  unstableBatchedUpdates(() => {
    useAuthStore.getState().updateTokenInfo(userTokenInfo);
  });
};
